<template>
<v-theme-provider :dark="dark">
    <div>

        <base-title :title="title" class="text-uppercase" space="1" />
        <base-divider :color="color" />

        <base-body>
            Her kommer der klippekort.
        </base-body>

        <v-list nav dense>
            <v-list-item-group active-class="deep-purple--text text--accent-4">
                <v-list-item v-for="voucher in vouchers" :key="vouchers.Rowkey" :ripple="false" active-class="text--primary" class="font-weight-bold" min-width="96" text>
                    <v-list-item-title>{{ voucher.title }}</v-list-item-title>
                      <v-list-item-subtitle>Kr. {{ voucher.price }},-</v-list-item-subtitle>
                </v-list-item>
            </v-list-item-group>
        </v-list>

        <base-btn class="mb-12" color="white" outlined>
            Køb klippekort
        </base-btn>
    </div>
</v-theme-provider>
</template>

<script>
import core from "./../../mixins/core";

export default {
    name: "BaseVouchers",

    props: {
        dark: Boolean,
        callout: String,
        color: {
            type: String,
            default: "primary",
        },
        icon: String,
        subtitle: String,
        text: String,
        title: String,
    },

    data: () => ({
        vouchers: false,
        business: [{
                icon: "mdi-map-marker-outline",
                title: "Address",
                text: "8553 N. Beach St. Ste. 227<br>Fort Worth, Texas 76137",
            },
            {
                icon: "mdi-cellphone",
                title: "Phone",
                text: "01 (800) 433 744<br>01 (800) 433 633",
            },
            {
                icon: "mdi-email",
                title: "Email",
                text: "john@vuetifyjs.com<br>heather@vuetifyjs.com",
            },
        ],
    }),
    mixins: [core],
    mounted() {
        this.fetchVouchers();
    },
    methods: {
        fetchVouchers() {
            this.getVouchers(0).then((vouchers) => {
                this.vouchers = vouchers;
            });
        },
    },
};
</script>
